import { RootState } from 'app/store';
import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { logoutAPIRequest } from '../api';
import { signOut } from './auth-slice';

export type TAction = {
  type: string;
};

export function* logoutSaga(): SagaIterator {
  try {
    const token = yield select((s: RootState) => s.user.accessToken);
    yield put(signOut());
    yield call(logoutAPIRequest, token);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
}
